import React, { useEffect } from 'react';
import styles from './Services.module.scss';
import { corpoFormation, employerIdNum, faqsCorporation } from "../../configration_data/configration"
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useConfig } from '../../../app/configcontext';
import { businessSlice } from '../../../features/business/businessSlice';
import ProtectedPaymentRoute from '../../auth/Auth';

export default function CorpoFormation() {
  ProtectedPaymentRoute()

  const actions = businessSlice.actions;
  
  const dispatch = useDispatch()
  const config = useConfig();
  const scorp = config && config?.scorp
  console.log("Scorp: ", scorp)
  const navigate = useNavigate()
  const userToken = localStorage.getItem("userToken")
  console.log("Usertoken :", userToken)

  useEffect(() => {
    if (userToken) {
      navigate("/payemnt")
    }
  }, [userToken])

  const business = useSelector((state) => state.business);
  const businessTypeId = business?.businessTypeId
  console.log("Business state: ", business?.businessLocation?.state)

  const handlePackageSelect = (selectedPackage) => {
    console.log("Selected corp package: ", selectedPackage.id)
    dispatch(actions.update_package_corp_id(selectedPackage.id))
    dispatch(actions.update_package_id(""))
    navigate("/business/Corp")
  };

  return (
    <div className="font-sans antialiased bg-white text-[#202124]">

      {/* Hero Section */}
      <section 
        className="relative overflow-hidden pt-[140px] pb-20 lg:pt-[180px] lg:pb-28 border-b border-[#0f2c4f] flex items-center justify-center"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1497366216548-37526070297c?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Professional Deep Blue Gradient Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835] via-[#04244d]/90 to-[#04244d]/40 mix-blend-multiply"></div>
        <div className="absolute inset-0 bg-[#021835]/50"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10 text-center flex flex-col items-center justify-center">
          <h1 className="text-4xl md:text-5xl lg:text-[4.2rem] font-medium leading-[1.12] mb-6 tracking-tight text-white max-w-4xl">
            Corporation Formation
          </h1>
          <p className="text-lg md:text-[1.15rem] text-white/80 leading-[1.7] font-normal max-w-2xl mx-auto">
            Set up your corporation with confidence. Built for scalability, investment readiness, and compliance.
          </p>
        </div>
      </section>

      {/* Set Up Your Corporation with Confidence */}
      <section className="py-20 lg:py-24 bg-white border-b border-[#f1f3f4]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Set Up Your Corporation with Confidence</h2>
            <p className="text-[17px] text-[#5f6368] max-w-3xl mx-auto">Forming a Corporation is ideal for businesses looking to issue stock and attract investors. Our Corporation formation service includes:</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
            {corpoFormation.map((ele) => (
              <div key={ele.id} className="flex gap-5 p-8 rounded-[8px] bg-[#f8f9fa] border border-[#f1f3f4] hover:shadow-[0_2px_12px_rgba(0,0,0,0.04)] transition-shadow duration-300">
                <div className="flex-shrink-0 w-8 h-8 bg-[#e8f0fe] rounded-full flex items-center justify-center text-[#1a73e8]">
                  <svg xmlns="http://www.w3.org/2000/svg" className="w-4 h-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                </div>
                <div>
                  <h3 className="text-[18px] font-semibold text-[#202124] mb-2">{ele.title}</h3>
                  <p className="text-[#5f6368] text-[15px] leading-relaxed">{ele.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* EIN Section with Fixed Background Image Parallax */}
      <section 
        className="relative py-24 lg:py-32 overflow-hidden bg-cover bg-center border-b border-[#0f2c4f]"
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2560&auto=format&fit=crop')",
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed'
        }}
      >
        {/* Deep Blue Parallax Overlay */}
        <div className="absolute inset-0 bg-gradient-to-r from-[#021835]/95 via-[#04244d]/90 to-[#063066]/95"></div>
        <div className="absolute inset-0 bg-[#021835]/40 backdrop-blur-[1px]"></div>

        <div className="container mx-auto px-4 lg:px-8 relative z-10">
          <div className="text-center mb-16">
            <span className="text-[#8ab4f8] font-medium tracking-wider uppercase text-sm mb-3 block">EIN Registration</span>
            <h2 className="text-3xl lg:text-[40px] font-medium text-white tracking-tight mb-4">Obtain Your EIN Quickly</h2>
            <p className="text-[17px] text-white/80 max-w-3xl mx-auto leading-relaxed">An Employer Identification Number (EIN) is essential for opening a business bank account, hiring employees, and handling tax matters.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {employerIdNum.map((ele) => (
              <div 
                key={ele.id} 
                className="bg-white/10 backdrop-blur-md p-8 rounded-[12px] border border-white/15 hover:bg-white/[0.14] hover:border-white/30 transition-all duration-300 shadow-xl flex flex-col justify-between group hover:-translate-y-1.5"
              >
                <div>
                  <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#1a73e8] to-[#1557b0] text-white flex items-center justify-center mb-6 shadow-[0_4px_16px_rgba(26,115,232,0.5)] group-hover:scale-110 transition-transform duration-300">
                    <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                  </div>
                  <h3 className="text-[20px] font-medium text-white mb-3 tracking-tight">{ele.title}</h3>
                  <p className="text-white/80 text-[15px] leading-relaxed font-light">{ele.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Section (Google Workspace / Cloud Style 3 Cards) */}
      <section className="py-20 lg:py-28 bg-[#f8f9fa] border-b border-[#dadce0]">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Transparent, professional pricing</h2>
            <p className="text-[17px] text-[#5f6368] max-w-2xl mx-auto">Choose the package that perfectly fits your business needs. No hidden fees, completely straightforward.</p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 items-stretch pt-4">
            {scorp && scorp?.map((ele, index) => {
              const isPopular = ele.name?.toLowerCase().includes("standard") || index === 1;
              const featureList = ele.description ? ele.description.split(/(?:,\s*|\s+plus\s+)/i).filter(Boolean) : [];

              return (
                <div 
                  key={ele.id} 
                  className={`bg-white rounded-[12px] p-8 flex flex-col justify-between transition-all duration-300 relative ${
                    isPopular 
                      ? 'border-2 border-[#1a73e8] shadow-[0_16px_40px_rgba(26,115,232,0.14)] lg:-translate-y-2.5 z-10' 
                      : 'border border-[#dadce0] shadow-sm hover:border-[#1a73e8] hover:shadow-md'
                  }`}
                >
                  {/* Most Popular Badge */}
                  {isPopular && (
                    <div className="absolute -top-3.5 left-1/2 -translate-x-1/2 bg-[#1a73e8] text-white text-[12px] font-semibold tracking-wider uppercase px-4 py-1 rounded-full shadow-md whitespace-nowrap">
                      Most Popular
                    </div>
                  )}

                  <div className="flex flex-col flex-grow">
                    {/* Header */}
                    <div className="mb-6 pb-5 border-b border-[#f1f3f4]">
                      <h3 className="text-[22px] font-medium text-[#202124] mb-1">{ele.name}</h3>
                      <p className="text-[#5f6368] text-[13.5px]">+ state filing fees</p>
                    </div>

                    {/* Price */}
                    <div className="mb-8">
                      <div className="flex items-baseline gap-1.5">
                        <h4 className="text-[44px] font-semibold text-[#1a73e8] leading-none tracking-tight">${ele.price}</h4>
                        <span className="text-[#5f6368] text-[14px]">/ one-time</span>
                      </div>
                    </div>

                    {/* Features Checklist */}
                    <div className="space-y-3.5 mb-8 flex-grow">
                      {featureList.map((item, idx) => (
                        <div key={idx} className="flex items-start gap-3">
                          <div className="flex-shrink-0 w-[18px] h-[18px] rounded-full border-[1.5px] border-[#1a73e8] flex items-center justify-center mt-0.5">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-[10px] h-[10px] text-[#1a73e8]" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>
                          </div>
                          <span className="text-[14.5px] text-[#3c4043] leading-snug">{item}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  {/* Action Button pinned to bottom */}
                  <button
                    onClick={() => handlePackageSelect(ele)}
                    className={`w-full py-3.5 rounded-[4px] font-medium text-[15px] cursor-pointer transition-all duration-300 ${
                      isPopular
                        ? 'bg-[#1a73e8] text-white hover:bg-[#1557b0] shadow-[0_4px_14px_rgba(26,115,232,0.35)]'
                        : 'bg-white border-2 border-[#1a73e8] text-[#1a73e8] hover:!bg-[#1a73e8] hover:!text-white'
                    }`}
                  >
                    Get started
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* FAQS Section */}
      <section className="py-20 lg:py-24 bg-[#f8f9fa]" id="faqs">
        <div className="container mx-auto px-4 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-3xl lg:text-[40px] font-medium text-[#202124] tracking-tight mb-4">Frequently Asked Questions</h2>
          </div>
          <div className="space-y-4 max-w-4xl mx-auto">
            {faqsCorporation.map((ele) => (
              <div key={ele.id} className="bg-white rounded-[8px] p-6 lg:p-8 border border-[#dadce0] shadow-sm">
                <h4 className="text-[17px] font-medium text-[#202124] mb-3">{ele.title}</h4>
                <div className="flex gap-4">
                  <p className="text-[#5f6368] text-[15px] leading-relaxed">{ele.para}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

